module.exports = __webpack_public_path__ + "img/Step9.213c9474.png";